<template>
  <LiefengContent>
    <template v-slot:title>需求评估</template>
    <template v-slot:toolsbarRight>
      <Form
        :model="searchForm"
        :label-colon="true"
        style="width: 624px"
        :inline="true"
      >
        <FormItem label="姓名">
          <Input
            :maxlength="20"
            v-model.trim="searchForm.name"
            placeholder="请输入姓名"
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem label="手机号">
          <Input
            :maxlength="20"
            v-model.trim="searchForm.mobile"
            placeholder="请输入手机号"
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button
          type="primary"
          icon="ios-search-outline"
          @click="search"
          style="margin-right: 10px"
          >查询</Button
        >
        <Button type="success" @click="reset" icon="ios-refresh">重置</Button>
        <Drawer
          title="查询条件"
          v-model="selectQuery"
          width="320"
          :styles="{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: '53px',
            position: 'static',
          }"
        >
          <Form :model="searchForm" :label-colon="true">
            <FormItem label="姓名">
              <Input
                v-model.trim="searchForm.name"
                placeholder="请输入姓名"
                :maxlength="20"
              ></Input>
            </FormItem>
            <FormItem label="手机号">
              <Input
                :maxlength="20"
                v-model.trim="searchForm.mobile"
                placeholder="请输入手机号"
              ></Input>
            </FormItem>
            <FormItem label="档案编号">
              <Input
                :maxlength="20"
                v-model.trim="searchForm.archiveNum"
                placeholder="请输入档案编号"
                style="width: 100%"
              />
            </FormItem>
            <FormItem label="所属社区">
              <Input
                :maxlength="20"
                v-model.trim="searchForm.orgName"
                placeholder="请输入所属社区"
              ></Input>
            </FormItem>
            <FormItem label="分类">
              <Select v-model="searchForm.difficultType">
                <Option
                  v-for="item in classificationList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="分级">
              <Select v-model="searchForm.difficultLevel">
                <Option
                  v-for="item in levelList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="跟进人">
              <Input
                :maxlength="20"
                v-model.trim="searchForm.staffName"
                placeholder="请输入跟进人"
              ></Input>
            </FormItem>
          </Form>
          <div class="demo-drawer-footer">
            <Button style="margin-right: 8px" @click="selectQuery = false"
              >取消</Button
            >
            <Button type="primary" @click="search">查询</Button>
          </div>
        </Drawer>
      </Form>
      <Button type="warning" @click="addDemand" icon="md-add">新增</Button>
      <Button
        type="primary"
        @click="$router.push('/archivesindex')"
        icon="ios-arrow-back"
        >返回</Button
      >
      <Icon
        type="md-more"
        @click="selectQuery = true"
        style="font-size: 24px; line-height: 32px; cursor: pointer"
        title="更多查询条件"
      />
    </template>
    <template v-slot:contentArea>
      <LiefengTable
        :talbeColumns="talbeColumns"
        :tableData="tableData"
        :total="total"
        :curPage="page"
        @hadlePageSize="hadlePageSize"
        :pagesizeOpts="[20, 30, 50, 100]"
        :loading="loading"
        :fixTable="true"
        :pageSize="pageSize"
      ></LiefengTable>

      <!-- 新增修改弹窗 -->
      <LiefengModal
        :title="addChangeTitle"
        :value="addChangeStatus"
        :fullscreen="true"
        @input="addChangeStatusFn"
        class="add-change"
      >
        <template v-slot:contentarea>
          <AddChangeDemand
            ref="addChangeDemand"
            @addChangeStatusFn="
              cancelModelTip = false;
              addChangeStatusFn(false);
            "
            @hadlePageSize="hadlePageSize"
            v-if="addChangeStatus"
            :userId="userId"
            :info="info"
            :identification="identification"
          ></AddChangeDemand>
        </template>
        <template v-slot:toolsbar>
          <Button
            type="info"
            @click="
              cancelModelTip = true;
              addChangeStatusFn(false);
            "
            style="margin-right: 10px"
            >关闭</Button
          >
          <Button type="primary" @click="saveDemand">保存</Button>
        </template>
      </LiefengModal>
      <!-- 查看弹窗 -->
      <LiefengModal
        title="查看信息档案"
        :value="seeDemandStatus"
        :fullscreen="true"
        @input="seeDemandStatusFn"
      >
        <template v-slot:contentarea>
          <SeeDemand
            v-if="seeDemandStatus"
            :showReferral="showReferral"
            tabName="name1"
            :info="info"
          ></SeeDemand>
        </template>
        <template v-slot:toolsbar>
          <Button type="primary" @click="seeDemandStatusFn(false)">关闭</Button>
        </template>
      </LiefengModal>

      <!-- 转介 -->
      <LiefengModal
        title="转介服务登记表"
        :value="referralStatus"
        :fullscreen="true"
        @input="referralStatusFn"
        class="referrak"
      >
        <template v-slot:contentarea>
          <Referral
            ref="referral"
            v-if="referralStatus"
            :archiveId="info"
            :infoId="info"
            @saveSuccess="saveSuccess"
          ></Referral>
        </template>
        <template v-slot:toolsbar>
          <Button
            type="info"
            @click="
              cancelModelTip = true;
              referralStatusFn(false);
            "
            style="margin-right: 10px"
            >关闭</Button
          >
          <Button type="primary" @click="referralSave(false)">保存</Button>
        </template>
      </LiefengModal>
    </template>
  </LiefengContent>
</template>

<script>
//@route('/archivesdemand')
import LiefengContent from "@/components/LiefengContent";
import LiefengTable from "@/components/LiefengTable";
import LiefengModal from "@/components/LiefengModal";
import AddChangeDemand from "@/views/archives/childrens/addChangeDemand";
import SeeDemand from "@/views/archives/childrens/seeDemand";
import Referral from "@/views/archives/childrens/referral";
export default {
  data() {
    return {
      selectQuery: false, //搜索抽屉
      searchForm: {},
      //搜索分类
      classificationList: [
        { label: "低保低收入对象", value: "1" },
        { label: "特困人员", value: "2" },
        { label: "留守老年人", value: "3" },
        { label: "独居孤寡老人", value: "4" },
        { label: "困境儿童", value: "5" },
        { label: "贫困重度残疾人", value: "6" },
        { label: "其他", value: "7" },
      ],
      //搜索分级
      levelList: [
        { label: "一级", value: "1" },
        { label: "二级", value: "2" },
        { label: "三级", value: "3" },
        { label: "四级", value: "4" },
      ],
      talbeColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "档案编号",
          key: "archiveNum",
          minWidth: 100,
          align: "center",
        },
        {
          title: "姓名",
          key: "name",
          width: 120,
          align: "center",
        },
        {
          title: "手机号",
          key: "mobile",
          width: 150,
          align: "center",
        },
        {
          title: "所属社区",
          key: "orgName",
          minWidth: 150,
          align: "center",
        },
        {
          title: "分类/人员类别",
          key: "difficultType",
          minWidth: 150,
          align: "center",
        },
        {
          title: "分级",
          key: "difficultLevel",
          width: 120,
          align: "center",
        },
        {
          title: "状态",
          key: "stageCode",
          width: 150,
          align: "center",
        },
        {
          title: "跟进人",
          key: "staffName",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "Dropdown",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h(
                    "Button",
                    {
                      props: {
                        type: "info",
                        size: "small",
                        icon: "ios-arrow-down",
                      },
                    },
                    "编辑"
                  ),
                  h(
                    "DropdownMenu",
                    {
                      slot: "list",
                    },
                    [
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: () => {
                              this.showReferral = params.row.stageCode == "已转介" ? true : false;
                              this.seeDemand(params.row.archiveId);
                            },
                          },
                          style: {
                            textAlign: "center",
                          },
                        },
                        "查看所有信息"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: () => {
                              this.changeDemand(
                                params.row.archiveId,
                                params.row.userId
                              );
                            },
                          },
                          style: {
                            textAlign: "center",
                          },
                        },
                        "修改需求评估"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: () => {
                              this.delDemand(params.row.archiveId);
                            },
                          },
                          style: {
                            textAlign: "center",
                          },
                        },
                        "删除需求评估"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: () => {
                              this.referral(params.row.archiveId);
                            },
                          },
                          style: {
                            textAlign: "center",
                            display:
                              params.row.stageCode == "已转介" ||
                              params.row.stageCode == "已停止服务"
                                ? "none"
                                : "",
                          },
                        },
                        "转介"
                      ),
                    ]
                  ),
                ]
              ),
            ]);
          },
        },
      ],
      tableData: [],
      total: 0,
      page: 1,
      loading: false,
      pageSize: 20,
      //新增/修改
      addChangeTitle: "",
      addChangeStatus: false,
      cancelModelTip: false, //fase代表不提示
      //标识新增修改 ,false代表新增
      identification: false,
      info: "",
      userId: "",

      //查看
      seeDemandStatus: false,
      showReferral: false,

      //转介
      referralStatus: false,
    };
  },
  methods: {
    // 删除
    delDemand(id) {
      this.$Modal.confirm({
        title: "温馨提示",
        content: "<p>您正在删除数据，是否继续？</p>",
        onOk: () => {
          this.$post("/archives/api/pc/archiveUser/deleteArchive", {
            archiveId: id,
          }).then((res) => {
            if (res.code == 200) {
              this.$Message.success({
                background: true,
                content: "删除成功",
              });
              this.hadlePageSize({
                page: this.page,
                pageSize: this.pageSize
              })
            } else {
              this.$Message.error({
                background: true,
                content: res.desc,
              });
            }
          });
        },
      });
    },
    //新增修改
    addChangeStatusFn(status) {
      if (!status && this.cancelModelTip) {
        this.$Modal.confirm({
          title: "温馨提示",
          className: "vertical-center-modal",
          content: "<p>确认要关闭窗口吗？未保存的信息不会保存</p>",
          onOk: () => {
            this.addChangeStatus = status;
          },
        });
      } else {
        this.addChangeStatus = status;
      }
    },
    addDemand() {
      this.addChangeTitle = "新增需求评估";
      this.identification = false;
      this.addChangeStatus = true;
    },
    changeDemand(id, userId) {
      this.addChangeTitle = "修改需求评估";
      this.info = id;
      this.userId = userId;
      this.identification = true;
      this.addChangeStatus = true;
    },
    //修改保存成功后执行
    saveSuccess() {
      this.cancelModelTip = false;
      this.referralStatus = false;
      this.hadlePageSize({
        page: this.page,
        pageSize: this.pageSize,
      });
    },
    saveDemand() {
      this.$refs.addChangeDemand.save();
    },
    //重置
    reset() {
      this.searchForm = {};
      this.hadlePageSize({
        page: this.page,
        pageSize: this.pageSize,
      });
    },
    //搜索
    search() {
      this.hadlePageSize({
        page: 1,
        pageSize: this.pageSize,
      });
    },
    hadlePageSize(obj) {
      this.loading = true;
      this.$post("/archives/api/pc/userNeedy/archiveQuestionPage", {
        ...this.searchForm,
        page: obj.page,
        pageSize: obj.pageSize,
        oemCode: parent.vue.oemInfo.oemCode,
        operatorId: parent.vue.loginInfo.userinfo.custGlobalId,
        operatorOrgCode: parent.vue.loginInfo.userinfo.orgCode
      })
        .then((res) => {
          if (res.code == 200 && res.dataList) {
            res.dataList.map((item, index) => {
              switch (item.difficultType) {
                case "1":
                  item.difficultType = "低保低收入对象";
                  break;
                case "2":
                  item.difficultType = "特困人员";
                  break;
                case "3":
                  item.difficultType = "留守老年人";
                  break;
                case "4":
                  item.difficultType = "独居孤寡老人";
                  break;
                case "5":
                  item.difficultType = "困境儿童";
                  break;
                case "6":
                  item.difficultType = "贫困重度残疾人";
                  break;
                case "7":
                  item.difficultType = "其他";
                  break;
              }
              switch (item.stageCode) {
                case "1":
                  item.stageCode = "需求评估";
                  break;
                case "2":
                  item.stageCode = "建立档案";
                  break;
                case "3":
                  item.stageCode = "服务阶段";
                  break;
                case "4":
                  item.stageCode = "已转介";
                  break;
                case "5":
                  item.stageCode = "停止服务";
                  break;
              }
              switch (item.difficultLevel) {
                case "1":
                  item.difficultLevel = "一级";
                  break;
                case "2":
                  item.difficultLevel = "二级";
                  break;
                case "3":
                  item.difficultLevel = "三级";
                  break;
                case "4":
                  item.difficultLevel = "四级";
                  break;
              }
            });
            this.tableData = res.dataList;
            this.pageSize = res.pageSize;
            this.total = res.maxCount;
            this.page = res.currentPage;
          } else {
            this.$Message.error({
              background: true,
              content: res.desc,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //查看
    seeDemand(id) {
      this.info = id;
      this.$Message.loading({
        content: "正在加载数据...",
        duration: 0
      })
      this.seeDemandStatus = true;
    },
    seeDemandStatusFn(status) {
      this.seeDemandStatus = status;
    },
    // 转介保存
    referralSave() {
      this.$refs.referral.save("demand");
    },
    //转介
    referralStatusFn(status) {
      if (!status && this.cancelModelTip) {
        this.$Modal.confirm({
          title: "温馨提示",
          className: "vertical-center-modal",
          content: "<p>确认要关闭窗口吗？未保存的信息不会保存</p>",
          onOk: () => {
            this.referralStatus = status;
          },
        });
      } else {
        this.referralStatus = status;
      }
    },
    referral(id) {
      this.info = id;
      this.referralStatus = true;
    },
  },
  created() {
    this.hadlePageSize({
      page: this.page,
      pageSize: this.pageSize,
    });
  },
  components: {
    LiefengContent,
    LiefengTable,
    LiefengModal,
    AddChangeDemand,
    SeeDemand,
    Referral,
  },
};
</script>
    
<style scoped lang='less'>
/deep/.ivu-form-item {
  margin-bottom: 0;
  width: 210px;
}
/deep/.ivu-drawer-body {
  .ivu-form-item {
    width: 100%;
  }
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.add-change,
.referrak {
  /deep/.ivu-icon-ios-close {
    display: none;
  }
}
</style>